<!-- <div *ngIf="loading">
  <app-loading-spinner></app-loading-spinner>
</div> -->
<router-outlet></router-outlet>
<router-outlet name="modal"></router-outlet>
<app-cookie-consent></app-cookie-consent>
